// hooks/useGetRoles.js
import { useQuery } from "@tanstack/react-query";
import { getAllRolesPermission } from "../../api/apiRoles";
import i18next from "i18next";

export function useGetRolesPermission() {

  const {
    isLoading,
    data: Permission,
    error,
  } = useQuery({
    queryKey: ["roles", i18next.language],
    queryFn: () => getAllRolesPermission(),
    retry: false,
  });

  return { isLoading, error, Permission };
}
